import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import type { CSSProperties } from "react";
import "../styles/Array.scss";
import { getSetsPerLine } from "../utils";

export const ArrayPdf = ({ entity }: { entity: StaticEntityType }) => {
  const { settings, children, id } = entity;
  const setsPerLine = Math.min(
    children.length,
    getSetsPerLine(children, settings),
  );

  const rows: any[][] = [];
  children.forEach((set: StaticEntityType, i: number) => {
    if (i % setsPerLine === 0) rows.push([]);

    rows[rows.length - 1].push(set);
  });

  return (
    <div className="combo arrayComboPdf tw-block tw-w-full tw-max-w-full">
      {rows.map((items, ri) => (
        <div
          key={ri}
          className="arrayComboPdf__row tw-grid tw-break-inside-avoid"
          style={{
            gridTemplateColumns: `repeat(${setsPerLine}, 1fr)`,
            gap: settings.setsSpace + "px",
            marginTop: ri > 0 ? settings.setsSpace + "px" : 0,
          }}
        >
          {items.map((set, ii) => (
            <div
              className="arrayComboPdf__row__item tw-flex"
              key={ii}
              style={
                {
                  "--justify-content":
                    settings.horizontalAlignment || "inherit",
                  "--align-items": settings.verticalAlignment || "inherit",
                } as CSSProperties
              }
            >
              <Set
                entity={{
                  ...set,
                  layers: {
                    ...(entity.layers || {}),
                    combo: { settings, index: ii, id },
                  },
                }}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
